import React, { useState } from 'react';
import './style.scss';
import { Slider as SliderAnt } from 'antd';

const Slider = ({ setValueSlider, min, max, step, value, unit }) => {
  const [marks, setMarks] = useState({
    0: `${value || 0} ${unit}`,
    [max]: `${max} ${unit}`,
  });

  const handleChangeSlider = (value) => {
    setValueSlider(value);

    const newMarks = {
      0: `${value} ${unit}`,
      [max]: `${max} ${unit}`,
    }
    setMarks(newMarks);
  }

  return (
    <div className="slider-custom">
      <SliderAnt
        min={min}
        max={max}
        step={step}
        marks={marks}
        value={value}
        onChange={handleChangeSlider}
      />
    </div>
  );
}

Slider.defaultProps = {
  min: 0,
  max: 1000,
  step: 1,
  value: 0,
  unit: 'MB'
};

export default React.memo(Slider);
